import type {UsersSearch} from "@project/application/admin";

import {listUsersQueryOptions} from "@project/application/admin";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {UsersPage} from "./-page/users.page";
import {UsersPending} from "./-page/users.pending";
import {usersSearchSchema} from "./-types";

export type {UsersSearch} from "./-types";

export const Route = createFileRoute("/_app/admin/users/")({
  // The parent layout route (users/route.tsx) owns the "Users" breadcrumb label.
  // We must explicitly set meta here to override the inherited parent staticData
  // (TanStack Router shallowly merges parent staticData into child matches), so
  // without this the index would duplicate "Users" as a second crumb on the list page.
  component: UsersPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    // If this is the first time the route is loaded, we want to block
    // the navigation, await the data, and show the Skeleton pendingComponent.
    if (cause === "enter") {
      return queryClient.ensureQueryData(listUsersQueryOptions(deps as UsersSearch));
    }

    // If we are just changing search params (pagination/filters) and staying
    // on the route, we do NOT await the query. We return immediately so the
    // component stays mounted and can handle its own 'isFetching' state while
    // using keepPreviousData. We fire prefetchQuery to start the request.
    void queryClient.prefetchQuery(listUsersQueryOptions(deps as UsersSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: UsersPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => usersSearchSchema.parse(search),
});
